module.exports = __webpack_public_path__ + "static/media/next.4c4a69f2.svg";